import { Autocomplete, Box, Button, Grid, Paper, Stack, Table, TableBody, TableCell, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Colors } from '../../../Styles/Colors'
import { DataGrid } from '@mui/x-data-grid'
import CommonGridHeader, { CommonDeleteButton, CommonEditButton } from '../../../Components/Common Components/CommonComponents'
import { CheckAccessFunc } from '../../../Components/CommonFunctions/CommonFunctions'
import { localGetItem } from '../../../Utility/Services/CacheProviderService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'

export default function ClinicalStaffMapping() {
    const [tblItem, settblItem] = useState({
        stafList: [],
        tblLoader: false,
        page: 0,
        rowsPerPage: 10,
    })
    const [mapValues, setmapVlues] = useState({
        clinicId: localGetItem('SelectedDoctorClinicId'),
        doctorNameData: [],
        clinicStaff: [],
        docName: null,
        staffName: null,
        staffIds: [],
        isEdit: false,
        editID: null,
    })
    const [message, setMessage] = useState({
        isErrorMsgText: '',
        successMsgText: '',
        isErrorMsg: false,
        successMsg: false,
    })

    useEffect(() => {
        getDoctorList()
        getClinicalStaff()
        getMappList()
    }, [])

    const errorMessage = (message) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: message,
        })
    }

    const successMessage = (message) => {
        setMessage({
            ...message,
            successMsg: true,
            successMsgText: message,
        })
    }
    const msgClose = () => {
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    const getMappList = () => {
        try {
            RestAPIService.getAll(Serviceurls.JMO_CLINICAL_STAFFMAP_GET)
                .then((response) => {
                    if (response.data.status === 'success') {
                        settblItem(prev => ({
                            ...prev,
                            stafList: response.data.data
                        }))
                    }
                })
                .catch((e) => {
                    errorMessage(e?.response?.data?.message || e.message)
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }
    const getDoctorList = () => {
        try {
            RestAPIService.getAll(Serviceurls.FO_CONFIG_OPDOCTORNAME + `?is_doctor_list=true`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        setmapVlues(prev => ({
                            ...prev,
                            doctorNameData: response.data?.data
                        }))
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const getClinicalStaff = () => {
        try {
            RestAPIService.getAll(Serviceurls.JMO_CLINICAL_STAFF_GET)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        let list = response.data?.data.filter((item) => item.is_active)
                        setmapVlues(prev => ({
                            ...prev,
                            clinicStaff: list
                        }))
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const postMapData = () => {
        try {
            let data = {
                "doctor": mapValues?.docName?.doctor_id || null,
                "clinical_staff": mapValues?.staffIds || [],
            }
            RestAPIService.create(data, Serviceurls.JMO_CLINICAL_STAFFMAP_GET)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        handleClear()
                        getMappList()
                    }
                })
                .catch((e) => {
                    errorMessage(e?.response?.data?.message || e.message)
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }
    const putMapData = () => {
        try {
            let data = {
                "doctor": mapValues?.docName?.doctor_id ? mapValues?.docName?.doctor_id : (mapValues?.docName?.id || null),
                "clinical_staff": mapValues?.staffIds || [],
            }
            RestAPIService.update(mapValues?.editID, data, Serviceurls.JMO_CLINICAL_STAFFMAP_GET)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        handleClear()
                        getMappList()
                    }
                })
                .catch((e) => {
                    errorMessage(e?.response?.data?.message || e.message)
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    tblItem.stafList?.forEach((element, index) => element.sno = index + 1)
    const columns = [
        { field: 'sno', headerName: 'S.No', sortable: false, flex: 0.10, },
        {
            field: 'doctor_name', headerName: 'Doctor Name', flex: 0.30, type: 'string',
            renderCell: (cellvalues) => {
                return (
                    <Box>{cellvalues?.row?.doctor_name?.length > 20 ?
                        <Tooltip placement="top" title={cellvalues?.row?.doctor_name} arrow>
                            <Typography fontSize={'.9vw'}>{cellvalues?.row?.doctor_name.slice(0, 20) + "..."}</Typography>
                        </Tooltip> : <Typography fontSize={'.9vw'}>{cellvalues?.row?.doctor_name || '-'}</Typography>}
                    </Box>
                )
            }
        },
        {
            field: 'clinical_staff_names', headerName: 'Clinical Staff', flex: 0.40, type: 'string',
            renderCell: (cellvalues) => {
                const staffString = cellvalues?.row?.clinical_staff_names?.join(', ') || '-';
                const displayText = staffString.length > 35 ? staffString.slice(0, 35) + '...' : staffString;
                return (
                <Box>
                    {staffString.length > 20 ? (
                        <Tooltip title={staffString} placement="top" arrow>
                            <Typography fontSize=".9vw">{displayText}</Typography>
                        </Tooltip>
                    ) : (
                        <Typography fontSize=".9vw">{displayText}</Typography>
                    )}
                </Box>

                )
            }
        },
        {
            field: 'action', headerName: 'Action', flex: 0.20, headerAlign: 'center', align: 'center',
            renderCell: (cellvalues) => {
                return (
                    <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
                        <CommonEditButton
                            disable={!CheckAccessFunc("front_office", "Settings", "Hospital Configuration", "Doctor List", "SubTab")?.editAccess}
                            size="1.5vw"
                            onClick={() => {
                                setmapVlues(prev => ({
                                    ...prev,
                                    docName: {
                                        id: cellvalues?.row?.doctor,
                                        doctor_name: cellvalues?.row?.doctor_name
                                    },
                                    staffIds: cellvalues?.row?.clinical_staff, // array of staff IDs
                                    staffName: mapValues?.clinicStaff?.filter(item =>
                                        cellvalues?.row?.clinical_staff?.includes(item.id)
                                    ),
                                    isEdit: true,
                                    editID: cellvalues?.row?.id
                                }));
                            }}
                        />
                    </Stack>
                )
            }
        },
    ]
    const handleClear = () => {
        setmapVlues(prev => ({
            ...prev,
            docName: null,
            staffName: null,
            staffIds: [],
            isEdit: false,
            editID: null,
        }))
    }

    const renderDoctor = () => {
        return (
            <Box>
                <Autocomplete
                    disableClearable
                    value={mapValues.docName || ""}
                    sx={{ width: "30vw" }}
                    size="small"
                    options={mapValues.doctorNameData}
                    getOptionLabel={option => typeof (option) === "string" ? option : option.doctor_name}
                    onChange={(event, val) => {
                        setmapVlues(prev => ({
                            ...prev,
                            docName: val
                        }))
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={"Select Doctor"}
                            InputProps={{
                                ...params.InputProps,
                            }}
                        />
                    )}
                />
            </Box>
        )
    }
    const renderStaff = () => {
        return (
            <Box>
                <Autocomplete
                    multiple
                    disableClearable={false} // Allow clearing in multi-select
                    disableCloseOnSelect
                    value={mapValues.staffName || []} // Must be an array
                    // disable={!this.mapValues.docName}
                    sx={{ width: "30vw" }}
                    size="small"
                    options={mapValues.clinicStaff}
                    getOptionLabel={(option) => typeof option === "string" ? option : option.name}
                    onChange={(event, val) => {
                        setmapVlues(prev => ({
                            ...prev,
                            staffName: val,
                            staffIds: val.map(v => v.id)
                        }));
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={"Select Clinical Staff"}
                        />
                    )}
                />
            </Box>
        )
    }
    const renderTbl = () => {
        return (
            <Box width={'30vw'} border={'1px solid rgb(205, 205, 205)'} height={'20vw'} borderRadius={'.2vw'}>
                <Box sx={{ height: '100%', overflowY: 'auto' }}>
                    <Table stickyHeader size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ color: Colors.SecondaryText, backgroundColor: Colors.Background, fontWeight: '600', fontSize: '0.9vw' }}>S.No</TableCell>
                                <TableCell sx={{ color: Colors.SecondaryText, backgroundColor: Colors.Background, fontWeight: '600', fontSize: '0.9vw' }}>Clinical Staff</TableCell>
                                <TableCell sx={{ color: Colors.SecondaryText, backgroundColor: Colors.Background, fontWeight: '600', fontSize: '0.9vw' }}>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {mapValues?.staffName?.length > 0 ? mapValues.staffName.map((list, i) => (
                                <TableRow key={i}>
                                    <TableCell>{i + 1}</TableCell>
                                    <TableCell>{list.name}</TableCell>
                                    <TableCell><CommonDeleteButton /></TableCell>
                                </TableRow>
                            )) : (
                                <TableRow>
                                    <TableCell colSpan={3}>No Records to Be Shown</TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </Box>
            </Box>
        )
    }
    const mapValidate = () => {
        if (!mapValues.docName) {
            errorMessage('Please Select Doctor')
            return;
        } else if (!mapValues.staffName || mapValues?.staffName?.length === 0) {
            errorMessage('Please Select Clinical Staff')
            return;
        } else {
            if (mapValues.isEdit) {
                putMapData()
            } else {
                postMapData()
            }
        }
    }

    // render
    return (
        <Box id="eMed_srvConfig_Container" sx={{ backgroundColor: Colors.configHomeBg }}>
            <Grid container spacing={3} className="eMed_srvConfig_Box">
                <Grid item xs={7.6}>
                    <Paper className="eMed_srvConfig_Div" >
                        <DataGrid
                            rows={tblItem.stafList}
                            columns={columns}
                            getRowId={(row) => row.sno}
                            localeText={{
                                toolbarColumns: "",
                                toolbarDensity: "",
                                toolbarExport: "",
                                toolbarFilters: "",
                                toolbarExportPrint: ""
                            }}
                            disableRowSelectionOnClick
                            components={{
                                Toolbar: CommonGridHeader.CommonToolBar,
                                NoRowsOverlay: () => {
                                    return (
                                        <Stack direction="row" justifyContent="center" alignItems="center" sx={{ height: "53vh" }}>
                                            {"No Records to Be Shown"}
                                        </Stack>
                                    )
                                }
                            }}
                            headerHeight={40}
                            rowCount={tblItem.stafList.length}
                            pageSizeOptions={[10, 20, 30]}
                            pagination
                            paginationMode="client"
                            paginationModel={{
                                page: tblItem.page,
                                pageSize: tblItem.rowsPerPage
                            }}
                            onPaginationModelChange={(model) => {
                                settblItem({
                                    ...tblItem,
                                    page: model.page,
                                    rowsPerPage: model.pageSize
                                })
                            }}
                            loading={tblItem.tblLoader}
                        />
                    </Paper>
                </Grid>
                <Grid item xs={4.4}>
                    <Paper className="eMed_srvConfig_Div">
                        <Box className='eMed_srvConfig_rightHead' style={{ backgroundColor: Colors.DataTblHeaderbg }}>
                            <Typography sx={{ fontWeight: 600, marginLeft: '1.5vw', color: '#616161' }}>{"Clinical Staff Configuration"}</Typography>
                        </Box>
                        <Box className="eMed_srvConfig_subDiv">
                            <Stack direction="row" justifyContent="center" alignItems="center" marginTop={'1vw'}>
                                {renderDoctor()}
                            </Stack>
                            <Stack direction="row" justifyContent="center" alignItems="center" marginTop={'1vw'}>
                                {renderStaff()}
                            </Stack>
                            {/* <Stack direction="row" justifyContent="center" alignItems="center" marginTop={'1vw'}>
                                {renderTbl()}
                            </Stack> */}
                        </Box>
                        <Stack spacing={2} direction="row" id='eMed_srvConfig_rightBtnCon' sx={{ backgroundColor: Colors.DataTblHeaderbg }} alignItems="center" justifyContent="center">
                            <Button variant='outlined' emed_tid="doctor_config_clear_btn" size="small" id="eMed_Config_btn" onClick={() => { handleClear() }}>{"Clear"}</Button>
                            <Button variant='contained' emed_tid="doctor_config_save_btn"
                                disabled={!CheckAccessFunc("front_office", "Settings", "Hospital Configuration", "Clinical Staff Mapping", "SubTab")?.editAccess}
                                size="small" id="eMed_Config_btn" onClick={() => { mapValidate() }}>{"Save"}</Button>
                        </Stack>
                    </Paper>
                </Grid>
            </Grid>
            {message.isErrorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={message.isErrorMsgText}
                    msgPop={msgClose}
                />
                : null}
            {message.successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={message.successMsgText}
                    msgPop={msgClose}
                />
                : null}
        </Box>
    )
}

